/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      StoreLocations {
        nextToken
        __typename
      }
      BusinessEntities {
        nextToken
        __typename
      }
      role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        role
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBusinessEntity = /* GraphQL */ `
  query GetBusinessEntity($id: ID!) {
    getBusinessEntity(id: $id) {
      id
      BusinessEntityStaff {
        nextToken
        __typename
      }
      BusinessEntityStoreLocation {
        nextToken
        __typename
      }
      name
      users {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBusinessEntities = /* GraphQL */ `
  query ListBusinessEntities(
    $filter: ModelBusinessEntityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBusinessEntities(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStoreLocation = /* GraphQL */ `
  query GetStoreLocation($id: ID!) {
    getStoreLocation(id: $id) {
      id
      StoreLocationActivityLogs {
        nextToken
        __typename
      }
      name
      businessentityID
      physicalAddress
      users {
        nextToken
        __typename
      }
      timezone
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStoreLocations = /* GraphQL */ `
  query ListStoreLocations(
    $filter: ModelStoreLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        businessentityID
        physicalAddress
        timezone
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const storeLocationsByBusinessentityID = /* GraphQL */ `
  query StoreLocationsByBusinessentityID(
    $businessentityID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelStoreLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    storeLocationsByBusinessentityID(
      businessentityID: $businessentityID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        businessentityID
        physicalAddress
        timezone
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStaff = /* GraphQL */ `
  query GetStaff($id: ID!) {
    getStaff(id: $id) {
      id
      name
      StaffActivityLogs {
        nextToken
        __typename
      }
      businessentityID
      hourlyRate
      pin
      phoneNumber
      email
      department
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStaff = /* GraphQL */ `
  query ListStaff(
    $filter: ModelStaffFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaff(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        businessentityID
        hourlyRate
        pin
        phoneNumber
        email
        department
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const staffByBusinessentityID = /* GraphQL */ `
  query StaffByBusinessentityID(
    $businessentityID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelStaffFilterInput
    $limit: Int
    $nextToken: String
  ) {
    staffByBusinessentityID(
      businessentityID: $businessentityID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        businessentityID
        hourlyRate
        pin
        phoneNumber
        email
        department
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getActivityLog = /* GraphQL */ `
  query GetActivityLog($id: ID!) {
    getActivityLog(id: $id) {
      id
      createdAt
      storelocationID
      staffID
      type
      saleAmountCard
      saleAmountCash
      commissionAmountCard
      commissionAmountCash
      tipAmountCard
      tipAmountCash
      giftCardAmount
      depositAmount
      updatedAt
      __typename
    }
  }
`;
export const listActivityLogs = /* GraphQL */ `
  query ListActivityLogs(
    $filter: ModelActivityLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivityLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        storelocationID
        staffID
        type
        saleAmountCard
        saleAmountCash
        commissionAmountCard
        commissionAmountCash
        tipAmountCard
        tipAmountCash
        giftCardAmount
        depositAmount
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const activityLogsByStorelocationID = /* GraphQL */ `
  query ActivityLogsByStorelocationID(
    $storelocationID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelActivityLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activityLogsByStorelocationID(
      storelocationID: $storelocationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        storelocationID
        staffID
        type
        saleAmountCard
        saleAmountCash
        commissionAmountCard
        commissionAmountCash
        tipAmountCard
        tipAmountCash
        giftCardAmount
        depositAmount
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const activityLogsByStaffID = /* GraphQL */ `
  query ActivityLogsByStaffID(
    $staffID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelActivityLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activityLogsByStaffID(
      staffID: $staffID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        storelocationID
        staffID
        type
        saleAmountCard
        saleAmountCash
        commissionAmountCard
        commissionAmountCash
        tipAmountCard
        tipAmountCash
        giftCardAmount
        depositAmount
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserStoreLocation = /* GraphQL */ `
  query GetUserStoreLocation($id: ID!) {
    getUserStoreLocation(id: $id) {
      id
      userId
      storeLocationId
      user {
        id
        role
        createdAt
        updatedAt
        __typename
      }
      storeLocation {
        id
        name
        businessentityID
        physicalAddress
        timezone
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserStoreLocations = /* GraphQL */ `
  query ListUserStoreLocations(
    $filter: ModelUserStoreLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserStoreLocations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        storeLocationId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userStoreLocationsByUserId = /* GraphQL */ `
  query UserStoreLocationsByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserStoreLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userStoreLocationsByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        storeLocationId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userStoreLocationsByStoreLocationId = /* GraphQL */ `
  query UserStoreLocationsByStoreLocationId(
    $storeLocationId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserStoreLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userStoreLocationsByStoreLocationId(
      storeLocationId: $storeLocationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        storeLocationId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserBusinessEntity = /* GraphQL */ `
  query GetUserBusinessEntity($id: ID!) {
    getUserBusinessEntity(id: $id) {
      id
      userId
      businessEntityId
      user {
        id
        role
        createdAt
        updatedAt
        __typename
      }
      businessEntity {
        id
        name
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserBusinessEntities = /* GraphQL */ `
  query ListUserBusinessEntities(
    $filter: ModelUserBusinessEntityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserBusinessEntities(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        businessEntityId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userBusinessEntitiesByUserId = /* GraphQL */ `
  query UserBusinessEntitiesByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserBusinessEntityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userBusinessEntitiesByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        businessEntityId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userBusinessEntitiesByBusinessEntityId = /* GraphQL */ `
  query UserBusinessEntitiesByBusinessEntityId(
    $businessEntityId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserBusinessEntityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userBusinessEntitiesByBusinessEntityId(
      businessEntityId: $businessEntityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        businessEntityId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
